module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUgMTBWMTguMzMzM0gxMi41VjEzLjMzMzNINy41VjE4LjMzMzNIMi41VjEwSDBMMTAgMEwyMCAxMEgxNy41Wk0xNi42NjY3IDUuMDc3NVYwLjgzMzMzM0gxNC4xNjY3VjIuNTc3NUwxNi42NjY3IDUuMDc3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/files/home.svg
// module id = IDQf
// module chunks = 1